/**
 * KPI value auto-fit arithmetic, kept pure so it is unit-testable.
 *
 * The value shares its row with an optional trailing icon and an
 * optional delta chip. Fitting the value to the whole card width (as
 * the original pass did) let it fill the row and shove the icon and
 * delta onto a new line. Only a delta that is already on the value's
 * line takes width from it; once the delta has wrapped below (narrow
 * tiles force that), the value gets the full row.
 */

export interface KpiRowMeasure {
  /** Content width of the value row, px. */
  rowWidth: number;
  /** Rendered width of the trailing icon, px (0 = none). */
  iconWidth: number;
  /** Rendered width of the delta chip, px (0 = none). */
  deltaWidth: number;
  /** Is the delta on the same line as the value? */
  deltaInline: boolean;
  /** Flex gap between row items, px. */
  gap: number;
}

export function kpiAvailableWidth(m: KpiRowMeasure): number {
  let w = m.rowWidth;
  if (m.iconWidth > 0) w -= m.iconWidth + m.gap;
  if (m.deltaWidth > 0 && m.deltaInline) w -= m.deltaWidth + m.gap;
  return Math.max(0, w);
}
